import React, {Component} from "react";
import TabBarNav from "./TabBarNav";
import classes from "./styles.module.css";

class HTabBar extends Component {
    state = {
        activeTab: null,
    };

    componentDidMount() {
        const {children, defaultActiveTab} = this.props;
        const childrenArray = React.Children.toArray(children).filter(Boolean);

        if (childrenArray.length > 0) {
            // Фильтруем только видимые вкладки
            const visibleChildren = childrenArray.filter(child => child.props.isVisible !== false);
            const visibleLabels = this.getChildrenLabels(visibleChildren);

            let activeTab;
            if (typeof defaultActiveTab === 'number' && visibleLabels[defaultActiveTab]) {
                activeTab = visibleLabels[defaultActiveTab];
            } else {
                activeTab = visibleLabels[0];
            }

            if (activeTab) {
                this.setActiveTab(activeTab);
            }
        }
    }

    scrollToActiveTab = () => {
        const activeTabElement = document.querySelector(`.${classes.Tab}[data-label="${this.state.activeTab}"]`);
        if (activeTabElement && activeTabElement.parentElement) {
            const navContainer = activeTabElement.parentElement;
            const offsetLeft = activeTabElement.offsetLeft;
            const offsetWidth = activeTabElement.offsetWidth;
            const containerWidth = navContainer.offsetWidth;

            navContainer.scrollTo({
                left: offsetLeft - containerWidth / 2 + offsetWidth / 2,
                behavior: 'smooth'
            });
        }
    };

    getChildrenLabels = (children) => {
        return React.Children.toArray(children)
            .filter(Boolean)
            .map((child) => child.props.label);
    };

    setActiveTab = (activeTab) => {
        const {activeTab: currentTab} = this.state;

        if (currentTab !== activeTab) {
            this.setState({activeTab}, () => {
                this.scrollToActiveTab();
            });
        }
    };

    renderTabs = () => {
        const {children} = this.props;
        const {activeTab} = this.state;

        return React.Children.toArray(children)
            .filter(Boolean)
            .map((tab) => {
                if (!tab || !tab.props) return null;
                return (
                    <TabBarNav
                        key={tab.props.label}
                        navLabel={tab.props.label}
                        navLabelColor={tab.props.labelColor}
                        navCount={tab.props.count}
                        isActive={activeTab === tab.props.label}
                        isVisible={tab.props.isVisible}
                        onChangeActiveTab={this.setActiveTab}
                    />
                );
            });
    };

    render() {
        const {activeTab} = this.state;
        const {children, ...attrs} = this.props;

        const childrenArray = React.Children.toArray(children).filter(Boolean);

        return (
            <div className={classes.Wrap} {...attrs}>
                <div className={classes.Nav}>{this.renderTabs()}</div>

                <div className={classes.Content}>
                    {childrenArray.map((child) =>
                        React.cloneElement(child, {activeTab})
                    )}
                </div>
            </div>
        );
    }
}

export default HTabBar;



// WEBPACK FOOTER //
// ./src/Components/Utils/HTabBar/index.js